<template>
    <v-row>
        <v-col cols="12">
            <v-card class="card--flex-toolbar">
                <v-toolbar
                    flat
                >
                    <v-toolbar-title class="grey--text">Reporte de clientes</v-toolbar-title>
                </v-toolbar>
                <v-container grid-list-md style="max-width: initial; padding: 20px;">
                    <v-form>
                        <v-row>
                            <v-col
                                xs="12"
                                md="6"
                            >
                                <v-dialog
                                    ref="dialog"
                                    v-model="modal_desde"
                                    :return-value.sync="filter.desde"
                                    persistent
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="filter.desde"
                                            label="Desde:"
                                            prepend-icon="event"
                                            readonly
                                            clearable
                                            @click:clear="filter.hasta = null"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        v-model="filter.desde"
                                        locale="es-MX"
                                        scrollable
                                    >
                                        <v-spacer/>
                                        <v-btn
                                            color="gray"
                                            @click="modal_desde = false"
                                        >
                                            Cancelar
                                        </v-btn>
                                        <v-btn
                                            color="primary"
                                            @click="$refs.dialog.save(filter.desde)"
                                        >
                                            Aceptar
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col
                                xs="12"
                                md="6"
                            >
                                <v-dialog
                                    ref="dialog2"
                                    v-model="modal_hasta"
                                    :return-value.sync="filter.hasta"
                                    persistent
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="filter.hasta"
                                            label="Hasta:"
                                            prepend-icon="event"
                                            :disabled="filter.desde === null"
                                            readonly
                                            clearable
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        v-model="filter.hasta"
                                        :min="filter.desde"
                                        locale="es-MX"
                                        scrollable
                                    >
                                        <v-spacer/>
                                        <v-btn
                                            color="gray"
                                            @click="modal_hasta = false"
                                        >
                                            Cancelar
                                        </v-btn>
                                        <v-btn
                                            color="primary"
                                            @click="$refs.dialog2.save(filter.hasta)"
                                        >
                                            Aceptar
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col xs="12" md="6">
                                <SearchClientesInput
                                    @selected="filter.cliente_id = $event"
                                ></SearchClientesInput>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>

                <v-card-actions>
                    <p class="font-weight-regular grey--text text--darken-2">
                        * De forma predeterminada se muestran los últimos 30 días si no aplicas los filtros de fecha
                    </p>
                    <v-spacer/>
                    <v-btn
                        color="blue darken-1"
                        class="white--text"
                        :loading="loading"
                        @click="listar()"
                    >
                        Buscar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
        <v-col cols="12">
            <v-data-table
                :headers="headers"
                :items="pedidos"
                :options.sync="options"
                class="elevation-1"
                :sort-by="'users.id'"
                :sort-desc="false"
                :loading="loading"
                :server-items-length="pedidosTotal"
                :footer-props="{itemsPerPageOptions : $root.OPTIONS_PER_PAGE_DATATABLE}"
                @update:options="listar"
            >
                <template v-slot:item.users.id="{item}">
                    {{ $_str_pad_left(item.id) }}
                </template>
                <template v-slot:item.pedidos_count="{item}">
                    {{ item.pedidos_count }}
                </template>
                <template v-slot:item.pedidos_monto="{item}">
                    {{ $_currency(item.pedidos_monto) }}
                </template>
                <template v-slot:body.append="props">
                    <tr>
                        <td colspan="2">Total página:</td>
                        <td class="text-center font-weight-bold">{{totalPedidosCountPorPagina}}</td>
                        <td class="text-right font-weight-bold">{{$_currency(totalPedidosMontoPorPagina)}}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
    import axios from 'axios';
    import SearchClientesInput from "@components/SearchClientesInput";

    export default {
        name: "PedidosPorCliente",
        components : {
            SearchClientesInput,
        },
        data(){
            return {
                filter : {
                    desde : null,
                    hasta : null,
                    cliente_id : []
                },
                headers: [
                    {
                        text: 'Id Cliente',
                        align: 'center',
                        sortable: true,
                        value: 'users.id',
                        width: '150px'
                    },
                    {
                        text: 'Cliente',
                        align: 'left',
                        sortable: false,
                        value: 'nombre_completo',
                        width: '150px'
                    },
                    {
                        text: 'Numero pedidos',
                        align: 'center',
                        sortable: true,
                        value: 'pedidos_count'
                    },
                    {
                        text: 'Importe',
                        align: 'right',
                        sortable: true,
                        value: 'pedidos_monto'
                    },
                    {
                        text: 'Último pedido',
                        align: 'right',
                        sortable: true,
                        value: 'ultimo_pedido'
                    },
                ],
                loading: false,
                modal_desde: false,
                modal_hasta: false,
                pedidos: [],
                pedidosTotal: 0,
                options: {
                    descending: true,
                    page: 1,
                    itemsPerPage: this.$root.OPTIONS_PER_PAGE_DATATABLE[0],
                    totalItems: 0
                },
            }
        },
        computed : {
            totalPedidosCountPorPagina(){
                return this.pedidos.reduce((total,item) => {
                   return total + parseInt(item.pedidos_count);
                },0);
            },
            totalPedidosMontoPorPagina(){
                return this.pedidos.reduce((total,item) => {
                    return total + parseFloat(item.pedidos_monto);
                },0);
            }
        },
        methods : {
            listar(){
                if(this.loading === false){

                    this.loading = true;
                    const {sortBy, sortDesc, page, itemsPerPage} = this.options;
                    axios.get('/api/reportes/clientes/pedidos', {
                        params: {
                            sortBy: sortBy, sortDesc: sortDesc, page: page, rowsPerPage: itemsPerPage,
                            search: this.search,
                            ...this.filter
                        }
                    })
                        .then((success) => {
                            this.loading = false;
                            let {data} = success;
                            this.pedidos = data.data;
                            this.pedidosTotal = data.total;
                            this.options.page = data.current_page;
                        }).catch(() => {
                            this.loading = false;
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>
